/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The duration type for the discount.
 */
export const CouponDurationType = {
  Forever: "forever",
  Once: "once",
  Repeating: "repeating",
} as const;
/**
 * The duration type for the discount.
 */
export type CouponDurationType = ClosedEnum<typeof CouponDurationType>;

/** @internal */
export const CouponDurationType$inboundSchema: z.ZodNativeEnum<
  typeof CouponDurationType
> = z.nativeEnum(CouponDurationType);
/** @internal */
export const CouponDurationType$outboundSchema: z.ZodNativeEnum<
  typeof CouponDurationType
> = CouponDurationType$inboundSchema;
